import { IFedevAuthEnvInterface, IFedevAuthInitOptions } from '@bmw-fedev/auth';

const IS_LOCAL_SERVE = globalThis.location?.hostname === 'localhost';

export const resolveAuthEnv = (
  env: IFedevAuthEnvInterface & { issuer: string }
): IFedevAuthEnvInterface & { issuer: string } => {
  if (!IS_LOCAL_SERVE) {
    return env;
  }
  try {
    const url = new URL(env.issuer);
    const isProd = url.hostname.includes('.prod.');
    const proxyPath = isProd
      ? url.pathname.replace('/auth/', '/auth-prod/')
      : url.pathname;
    return { ...env, issuer: proxyPath };
  } catch {
    return env;
  }
};

export const resolveAuthInitOptions = (
  env: { issuer: string },
  baseOptions: Partial<IFedevAuthInitOptions> = {}
): IFedevAuthInitOptions => {
  if (!IS_LOCAL_SERVE) {
    return { config: { ...baseOptions.config } };
  }
  const url = new URL(env.issuer);
  const isProd = url.hostname.includes('.prod.');
  const realmPath = isProd
    ? url.pathname.replace('/auth/', '/auth-prod/')
    : url.pathname;
  return {
    config: {
      ...baseOptions.config,
      callDiscoveryDocument: false,
      skipIssuerCheck: true,
      loginUrl: `${realmPath}/authorize`,
      logoutUrl: `${realmPath}/connect/endSession`,
      tokenEndpoint: `${realmPath}/access_token`,
      userinfoEndpoint: `${realmPath}/userinfo`,
      sessionCheckIFrameUrl: `${realmPath}/connect/checkSession`,
      revocationEndpoint: `${realmPath}/token/revoke`,
    },
  };
};
